import { useState } from "react";

const totalQuestions = 10;
const difficulty = "easy";

type PreguntatresGameHook = [
  number,
  {
    question: string;
    answers: {
      a1: (string | boolean)[];
      a2: (string | boolean)[];
      a3: (string | boolean)[];
      a4: (string | boolean)[];
    };
  }[],
  10,
  number,
  string,
  React.Dispatch<React.SetStateAction<string>>,
  (correct: boolean, target: Element) => void,
  () => void,
  () => void
];

export default function usePreguntatresGame(): PreguntatresGameHook {
  const [questionsInfo, setQuestionsInfo] = useState([
    {
      question: "",
      answers: {
        a1: ["", false],
        a2: ["", false],
        a3: ["", false],
        a4: ["", true]
      }
    }
  ]);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(-1);
  const [correctAnswersCount, setCorrectAnswersCount] = useState(0);
  const [canSelect, setCanSelect] = useState(false);

  //Para el nombre del jugador
  const [name, setName] = useState("");

  const generateQuestions = () => {
    //Se hace una peticion a la api
    fetch(
      `https://opentdb.com/api.php?amount=${totalQuestions}&difficulty=${difficulty}&type=multiple`
    )
      .then(response => response.json())
      .then(data => {
        //Se recrea el array del resultado, para que sea mas acorde
        const dataInfo = data.results.map(
          (r: {
            question: string;
            incorrect_answers: string[];
            correct_answer: string;
          }) => {
            const info = {
              question: decodeHtml(r.question),
              answers: [
                ...r.incorrect_answers.map(incorrect => [
                  decodeHtml(incorrect),
                  false
                ]),
                [decodeHtml(r.correct_answer), true]
              ]
            };
            //Se cambian de lugar las respuestas
            shuffleAnswers(info.answers);
            return info;
          }
        );
        setQuestionsInfo([...dataInfo]);
        setCanSelect(true);
        setCurrentQuestionIndex(0);
      });
  };

  const onAnswerClick = (correct: boolean, target: Element) => {
    //Evitamos que se presione varias veces una respuesta
    if (!canSelect) return;

    //Se obtiene la respuesta correcta para agregarle el color
    //esto es para que al seleccionar la incorrecta, se sepa cual es la correcta
    const correct_answer = document.getElementById("correctAnswer");
    if (correct_answer) correct_answer.classList.add("c");

    //Se pinta la respuesta dependiendo de si es correcta o no
    target.classList.add(correct ? "c" : "i");
    setCanSelect(false);
    //Se agranda el numero de respuestas correctas, si respondió bien
    setCorrectAnswersCount(x => (correct ? x + 1 : x));
    //Se establece un timeout, para que pueda ver la respuesta correcta
    setTimeout(() => {
      //Quitamos los colores de las respuestas
      if (correct_answer) correct_answer.classList.remove("c");
      target.classList.remove(correct ? "c" : "i");

      //Se continua con la siguiente pregunta
      const current = currentQuestionIndex;
      if (currentQuestionIndex < totalQuestions - 1) {
        setCurrentQuestionIndex(() => current + 1);
        setCanSelect(true);
      }
      //Evitamos que se sobrepase el numero
      else {
        setCurrentQuestionIndex(totalQuestions);
      }
    }, 1000);
  };

  const restartGame = () => {
    setCurrentQuestionIndex(-1);
  };

  return [
    currentQuestionIndex,
    questionsInfo,
    totalQuestions,
    correctAnswersCount,
    name,
    setName,
    onAnswerClick,
    generateQuestions,
    restartGame
  ];
}

const shuffleAnswers = (array: (string | boolean)[][]) => {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    const temp = array[i];
    array[i] = array[j];
    array[j] = temp;
  }
};

function decodeHtml(html: string) {
  const txt = document.createElement("textarea");
  txt.innerHTML = html;
  return txt.value;
}
